<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Company Banks
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Company Banks"
      text="Create Company Banks"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="company"
                v-validate="'required'"
                :items="companies"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-selected
                label="Company"
                :error-messages="errors.collect('company')"
                data-vv-name="company"
                data-vv-as="company"
              />
            </v-col>
          </v-row>

          <v-row>  
            <v-col>
              <span class="font-weight-bold pr-2">Banks:</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon
                    color="primary"
                    v-on="{ ...dialog, ...tooltip }"
                    @click="addRow"
                  >
                    mdi-plus
                  </v-icon>
                </template>
                <span>Add new row</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row
            v-if="details.length>0"
            no-gutters
          >
            <v-col class="font-weight-bold">
              Default Bank
            </v-col>
          </v-row>

          <v-row
            v-for="(detail,counter) in details"
            :key="counter"
          >
            <v-col class="py-0">
              <v-checkbox
                v-model="detail.is_default"
                @click="defaultBank(counter)"
              />
            </v-col>
          
            <v-col
              cols="3" 
              class="py-0"
            >
              <v-autocomplete
                v-model="detail.payroll_bank"
                v-validate="'required'"
                :items="payrollBanks"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-selected
                label="Banks"
                :error-messages="errors.collect('payroll_bank' + counter)"
                :name="'payroll_bank' + counter"
                data-vv-as="banks"
              />
            </v-col>

            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-model="detail.bank_account_no"
                v-validate="bankValidate(details[counter].payroll_bank)"
                :name="'bank_account_no' + counter"
                label="Bank Account No."
                :error-messages="errors.collect('bank_account_no' + counter)"
                data-vv-as="bank account no"
              />
            </v-col>

            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-show="details[counter].payroll_bank === 19"
                v-model="detail.originator_id"
                v-validate="originatorIdValidate(details[counter].payroll_bank)"
                :error-messages="errors.collect('originator_id' + counter)"
                :name="'originator_id' + counter"
                label="Originator ID"
                data-vv-as="originator id"
              />
            </v-col>

            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-show="details[counter].payroll_bank === 19"
                v-model="detail.company_registered_id"
                v-validate="companyRegisteredIdValidate(details[counter].payroll_bank)"
                :name="'company_registered_id' + counter"
                label="Company Registered ID"
                :error-messages="errors.collect('company_registered_id' + counter)"
                data-vv-as="company registered id"
              />
            </v-col>

            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-show="details[counter].payroll_bank === 19"
                v-model="detail.short_name"
                v-validate="shortNameValidate(details[counter].payroll_bank)"
                :name="'short_name' + counter"
                label="Short Name"
                :error-messages="errors.collect('short_name' + counter)"
                data-vv-as="short name"
              />
            </v-col>

            <v-col
              class="py-0"
              style="display:flex"
            >
              <v-icon
                v-if="!detail.is_default"
                color="error"
                @click="deleteRow(counter)"
              >
                mdi-window-close
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      companyBanks: {
        type: Array,
        default: () => {
          return []
        },
      },    
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        companies: [],
        company: null,
        details: [{ payroll_bank: null, originator_id: null, company_registered_id: null, short_name: null, bank_account_no: null, is_default: 1 }],
        payrollBanks: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       

        this.resetForm()

        Promise.all([
          this.$api.companies().list(),
          this.$api.payrollBanks().list(),
        ])
          .then(([company, payrollBank]) => {
            let addedCompanyId = this.companyBanks.map(item => {
              return item.company.id
            })
            this.companies = company.data.filter(item => {
              return !addedCompanyId.includes(item.id)
            })        

            this.payrollBanks = payrollBank.data
          })
      },
    },
    methods: {
      bankValidate (id) {
        if (!id) return 'required'
        if (id === 19) return 'required|max:12' // maybank
        return 'required'
      },

      originatorIdValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:5' // maybank
        return ''
      },

      companyRegisteredIdValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:3' // maybank
        return ''
      },

      shortNameValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:13' // maybank
        return ''
      },

      defaultBank (index) {
        this.details.map((item, i) => {
          if (i === index) {
            item.is_default = 1
          } else {
            item.is_default = 0
          }
        })
      },

      addRow () {
        this.details.push({ payroll_bank: null, originator_id: null, company_registered_id: null, short_name: null, bank_account_no: null, is_default: 0 })
      },
      
      deleteRow (counter) {
        this.details.splice(counter, 1)
      },
      
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.companyBanks().create({ company: this.company, banks: this.details })
              .then((res) => {
                this.$emit('created')            
                this.$snack({ message: 'Added new company banks' })

                this.progressing = false
                this.dialog = false        
              })
              .catch(() => {
                this.$snack({ color: 'error', message: 'Error adding company banks' })
                this.progressing = false
              })
          })
      },

      resetForm () {
        this.$validator.reset()
        this.company = null
        this.details = [{ payroll_bank: null, originator_id: null, company_registered_id: null, short_name: null, bank_account_no: null, is_default: 1 }]
      },
    },
  }
</script>
